import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    width: 128px;
    height: 100%;
`;
